import axios from 'axios';
import { put, takeLatest } from 'redux-saga/effects';
import { api_prefix } from '../../Constants/constants';
import {
  clearErrorField,
  emailVerify,
  emailVerifyReceived,
  passwordUpdate,
  passwordUpdateReceived
} from '../reducers/ForgotPassword';
import { showError } from '../../CommonUtilities/CommonUtilities';

function* emailVerifySaga({ payload }: any) {
  try {
    const url = `${api_prefix}change_password/forgot_password/`;

    yield put(clearErrorField());
    const response = yield axios.post(url, payload);
    yield put(
      emailVerifyReceived({
        isEmailVerified: true,
        message: response?.data?.message || '',
        errorCode: response?.status ?? null
      })
    );
  } catch (error: any) {
    yield put(
      emailVerifyReceived({
        isEmailVerified: false,
        message:
          error?.response?.data?.message || error.response?.data?.email?.[0],
        errorCode: error?.response?.status ?? null
      })
    );
  }
}

function* passwordUpdateSaga({ payload }: any) {
  try {
    const url = `${api_prefix}change_password/update_password/`;
    const json = yield axios
      .post(url, payload)
      .then((response) => response.data);
    yield put(
      passwordUpdateReceived({
        isPasswordUpdated: true,
        message: json.message
      })
    );
  } catch (error: any) {
    showError(error);
    if (error.response?.data?.message[0] === 'Reset password link expired') {
      setTimeout(() => {
        window.location.href = '/login';
      }, 3000);
    }
    yield put(
      passwordUpdateReceived({
        isPasswordUpdated: false,
        message: error.response.data.password[0]
      })
    );
  }
}

export default function* watchForgotPassword() {
  yield takeLatest(emailVerify, emailVerifySaga);
  yield takeLatest(passwordUpdate, passwordUpdateSaga);
}
